<template>
    <div class="permission-info">
        <span class="material-icons mr-2">{{ icon }}</span>
        <span>{{ text }}</span>
    </div>
</template>

<script>
export default {
    name: 'PermissionInfo',
    props: {
        icon: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.permission-info {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 0 0.5rem;

    span {
        color: #444;
        font-size: 0.9rem;
        
        &.material-icons {
            color: #666;
            font-size: 1rem;
            margin-right: 8px;
            width: 20px;
        }
    }
}
</style> 